// extracted by mini-css-extract-plugin
export var active = "_21-9";
export var backButton = "_21-8";
export var clone = "_21-e";
export var collapseBar = "_21-j";
export var collapseMode = "_21-l";
export var collapsed = "_21-n";
export var dragHandle = "_21-c";
export var dropdownIcon = "_21-g";
export var expanding = "_21-m";
export var hidden = "_21-w";
export var iconContainer = "_21-p";
export var iconSwapper = "_21-v";
export var navItem = "_21-6";
export var navItemIcon = "_21-f";
export var navProfile = "_21-7";
export var notificationCountBadge = "_21-i";
export var notificationDot = "_21-q";
export var optionsContainer = "_21-h";
export var primaryNav = "_21-0";
export var primaryNavDivider = "_21-u";
export var primaryNavResizeHandle = "_21-2";
export var primaryNavResizing = "_21-1";
export var primaryNavTabSection = "_21-t";
export var primaryTab = "_21-o";
export var primaryTabIconBox = "_21-r";
export var secondaryNav = "_21-3";
export var selected = "_21-s";
export var settingsNav = "_21-4";
export var settingsNavItems = "_21-5";
export var show = "_21-d";
export var sideNav = "_21-k";
export var teamItem = "_21-a";
export var userProfileItem = "_21-b";